import { useState } from 'react'
import { useSelector } from 'react-redux'
import vanBangChoDuyetProcessor from '../../../processor/vanBangChoDuyetProcessor'
import { dateToDDMMYY } from '../../../utils/date'
import ListVanBangWithView from '../ListVanBangWithView'
import ViewVanBang from '../ViewVanBang'

const processor = vanBangChoDuyetProcessor

export default function ChuaDuyet() {
  const [reload, setReload] = useState(false)
  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)
  const additionColumn = [
    {
      value: 'chinhSuaVanBangs',
      name: 'Thông tin phản hồi',
      render: (data) => {
        return (
          <div>
            {data.phanHois &&
              data.phanHois
                .filter((item) => item.noiDung)
                .map((item) => (
                  <p>{`[${dateToDDMMYY(new Date(item.createDate))}] ${item.user.fullname}: ${
                    item.noiDung
                  }`}</p>
                ))}
          </div>
        )
      },
    },
  ]
  const save = async (data) => {
    const rs = await processor.upsert(data)
    let message
    if (data.id) {
      message = rs.data
    } else {
      message = rs.isSuccess ? 'Thêm mới thành công' : rs.data
    }
    if (rs.isSuccess) setReload(true)
    toast({ type: rs.isSuccess ? 'success' : 'error', message })
    return rs
  }
  const deleteOnClick = async (id) => {
    if (confirm) {
      const rs = await processor.delete(id)
      toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
      if (rs.isSuccess) setReload(true)
    }
  }
  const buttons = [
    (data) => {
      return {
        location: 'after',
        icon: 'pi pi-trash',
        className: 'p-button-rounded p-button-danger mr-2',
        tooltip: 'Xoá',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          confirm({
            action: () => deleteOnClick(data.id),
            body: `Bạn có muốn xoá văn bằng này?`,
          })
        },
      }
    },
  ]
  return (
    <>
      <ListVanBangWithView
        headerLeft={
          <ViewVanBang
            disabled={['khoaThiId']}
            data={{ khoaThiId }}
            btnProps={{ className: 'p-button-success', label: 'Thêm mới', icon: 'pi pi-plus' }}
            action={(data) => save(data)}
            canEdit
          />
        }
        moduleTitle="Danh sách văn bằng chưa duyệt"
        getMethod={processor.getByKhoaThi}
        reload={reload}
        setReload={setReload}
        additionColumn={additionColumn}
        canEdit
        buttonsAfter={buttons}
        action={(data) => save(data)}
      />
    </>
  )
}
